export const mapMotionDefaults = Object.freeze({
  pointEffect: 'diffuse', motionPeriod: 4, motionStrength: 45,
  motionColor: '', locationUpdateFlash: true
})

const number = (value, fallback, min, max) => Number.isFinite(Number(value)) && value !== '' && value != null
  ? Math.max(min, Math.min(max, Number(value))) : fallback

export function mapMotionOptions (input = {}) {
  return {
    pointEffect: ['normal', 'ripple', 'breath', 'diffuse'].includes(input.pointEffect) ? input.pointEffect : mapMotionDefaults.pointEffect,
    motionPeriod: number(input.motionPeriod, 4, 2, 10),
    motionStrength: number(input.motionStrength, 45, 0, 100),
    motionColor: typeof input.motionColor === 'string' ? input.motionColor.slice(0, 80) : '',
    locationUpdateFlash: input.locationUpdateFlash !== false
  }
}

export function motionKey (row) {
  if (row.regionCount) return 'region:' + String(row.regionId || row.name || '')
  if (row.clusterRows) return 'cluster:' + (row.bounds || [row.lng, row.lat]).join(':') + ':' + (row.clusterCount || row.clusterRows.length)
  return String(row.deviceId || row.name || '') + ':' + (row.deviceId ? '' : row.lng + ':' + row.lat)
}

export function motionPhase (key) {
  let hash = 2166136261
  for (let index = 0; index < key.length; index++) hash = Math.imul(hash ^ key.charCodeAt(index), 16777619)
  return (hash >>> 0) / 4294967296
}
